import {register} from '@shopify/theme-sections';

const selectors = {
  slider: '[data-slider]',
};

export default register('collection-header', {
  onLoad() {
    const container = this.container;
    const shopCollectionsSlider = $(selectors.slider, container);
    if (!shopCollectionsSlider) return;

    const shopCollectionsSliderSettings = {
      dots: false,
      arrows: false,
      waitForAnimate: false,
      rows: 0,
      slidesToShow: 2.25,
      slidesToScroll: 2,
      infinite: false,
      mobileFirst: true,
      responsive: [
        {
          breakpoint: 575,
          settings: {
            slidesToShow: 3.25,
            slidesToScroll: 3,
          },
        },
        {
          breakpoint: 991,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            arrows: true,
          },
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
            slidesToScroll: 4,
            arrows: true,
          },
        },
      ],
    };

    shopCollectionsSlider.slick(shopCollectionsSliderSettings);
  },
});
